import { Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../shared/shared.service';
import { TagsService } from '../tags.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material/paginator';
import { UserService } from '../../user/user.service';
import * as XLSX from 'xlsx';
// import * as $ from 'jquery';
//Jquery
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit, AfterViewInit {
    willDownload = false;

    public form: FormGroup;
    public form2: FormGroup;

    public filter: FormGroup;
    public total_items: number;
    public pag_size: number;
    public pag_number: number;
    public list: any;
    public itemQuantity = [];
    public tags = [];
    selectedCity = [];
    public tagId : any;
    public dataExcel: any = [];

    public action : any;

    cities: any = [];
    selectedItems: any = [];
    dropdownSettings: any = {};

    ShowFilter = false;
    disabled = false;

    selectStatus = 1;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('closebutton') closebutton;
    @ViewChild('selectDropdown') selectDropdown;

    public dataSource = new MatTableDataSource;

    public displayedColumns = [
        'id',
        'colum1',
        'colum2',
        'colum3',
        'colum4',
        'colum5',
        'status',
        'edit',
        'delete',
    ];

    constructor(
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private _sharedService: SharedService,
        private _tagsService: TagsService,
        public toastr: ToastsManager,
        private _router: Router,
        private logger: Logger,
        private userService: UserService,
    ) {
        this.form = this.fb.group({
            detalle: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]]
        });

        this.filter = this.fb.group({
            textoFiltro: [],
            city : []
        });

        this.form2 = this.fb.group({
            selectEtiquetasId: [''],
            avaliable: ['']
        });

        this.pag_size = 10;
        this.pag_number = 1;
    }

    

    addCustomUser = (term) => ({id: term, name: term});

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    ngOnInit() {
        this.updatePage();
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    updatePage() {
        this.spinner.show();

        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            limit: this.pag_size, // quantity of items
            page: this.pag_number  // page
        };

        this._tagsService.getAllTags(data).subscribe(
            data => { 
                this.list = data.data.tags; //data list

                this.tags = Array.from({length: this.list.length}, (value, key) => key)
                .map(val => ({
                    id: this.list[val].id,
                    name: this.list[val].description
                }));
            },
            error => { //server error
                //this.load = false;
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    
        this._tagsService.getlistTags(data).subscribe(
            data => {
                //this.load = false;
                this.spinner.hide();
                if (data.status) { //success
                    this.dataSource.data = data.data.tagsAssociation;
                    console.log(this.dataSource.data);
                    this.dataSource.sort = this.sort;
                   // this.paginator._showFirstLastButtons = true;
                    this.paginator._intl.itemsPerPageLabel = '';
                    this.dataSource.paginator = this.paginator;

                    for( let i in data.data.tagsAssociation){
                        
                        let tempExcel = [];    
                        tempExcel['Id']= this.dataSource.data[i].id;
                        tempExcel['Nivel 1']= this.dataSource.data[i].colum1;
                        tempExcel['Nivel 2']= this.dataSource.data[i].colum2;
                        tempExcel['Nivel 3']= this.dataSource.data[i].colum3;
                        tempExcel['Nivel 4']= this.dataSource.data[i].colum4;
                        tempExcel['Nivel 5']= this.dataSource.data[i].colum5;

                        let status = this.dataSource.data[i].status;
                        if(status=='0'){
                            status="Inactivo"
                        }else{
                            status="Activo"
                        }
                        tempExcel['Estado']= status;

                        this.dataExcel.push(tempExcel);

                    }
                   // this.list = data.data.tags.data; //data list

                    // this.tags = Array.from({length: this.list.length}, (value, key) => key)
                    // .map(val => ({
                    //     id: this.list[val].id,
                    //     name: this.list[val].description
                    // }));

                    //this.selectedCity = [this.tags[2].id, this.tags[0].id];
                    //console.log(this.selectedCity);

                    this.total_items = data.data.total;
                    this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
                } else { // API error
                    this.toastr.error(data.message, 'Error');
                }

            },
            error => { //server error
                //this.load = false;
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    }

    newAssociation() {
        this.form2.value.auth_token = this._sharedService.getCookie('auth_token');

        this._tagsService.newAssociation(this.form2.value).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) {

                    if (data.message == 'tags.exists') {
                        this.toastr.warning('La combinación seleccionada de etiquetas ya existe', 'Error');
                        return;
                    }
                    
                    this.closebutton.nativeElement.click();
                    this.selectDropdown.handleClearClick();
                    this.updatePage();
                    this.toastr.success('La etiqueta ha sido creada correctamente!', '¡Éxito!');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    }

    onEdit(id) {
        this.tagId = id;

        this.spinner.show();
		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			id: id
		};

		// initialized the status
		this._tagsService.getTags(data).subscribe(
			data => {
				this.logger.log(data);
				if (data.status) {
                    

                    let idTags = data.data.tags.id_tags;
                    let splitted = idTags.split(",");

                    let selectId = [];

                    splitted.forEach((element, index) =>{
                        this.tags.forEach((element2, index) =>{
                            if (this.tags[index].id == element) {
                                selectId.push(this.tags[index].id);
                            }
                        })
                    });

                    this.action = 'update';

                    this.selectedCity = selectId;

                    this.form2.setValue({
                        avaliable: data.data.tags.status,
                        selectEtiquetasId : selectId
                    });

                    $('#associateTag').modal('toggle', { backdrop: false });
                    $('#associateTag').appendTo("body");

					/*this.form.setValue({
						id: data.data.tags,
						detalle: data.data.tags.description,
						avaliable: data.data.tags.status,
					});*/
					this.spinner.hide();

				} else {
					this.toastr.error(data.message, 'Error');
					this.spinner.hide();
				}
			
			},
			error => {
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
				this.logger.log(error);

			}
		);
    }

    newTags() {
        $('#newTags').modal('toggle', { backdrop: false });
        $('#newTags').appendTo("body"); 
    }

    associateTag() {
        this.action = 'new';
        this.selectDropdown.handleClearClick();
        $('#associateTag').modal('toggle', { backdrop: false });
        $('#associateTag').appendTo("body");
    }

    updateAsocciation() {
        this.form2.value.auth_token = this._sharedService.getCookie('auth_token');
        this.form2.value.id = this.tagId;

        this._tagsService.updateAsocciation(this.form2.value).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) {

                    if (data.message == 'tags.exists') {
                        this.toastr.warning('La combinación seleccionada de etiquetas ya existe', 'Error');
                        return;
                    }
                    
                    this.closebutton.nativeElement.click();
                    this.selectDropdown.handleClearClick();
                    this.updatePage();
                    this.toastr.success('La etiqueta ha sido creada correctamente!', '¡Éxito!');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );

        console.log(this.form2.value);
    }

    onNew() {
        this.spinner.show();

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            detalle: this.form.value.detalle,
            avaliable: this.form.value.avaliable
        };

        this._tagsService.newTags(data).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) {
                    $('#detalle').val("");
                    $("#selectStatus").val("1");
                    this.updatePage();
                    this.toastr.success('La etiqueta ha sido creada correctamente!', '¡Éxito!');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    }

    onDelete(id: string) {
        $('#DeleteUser').modal('toggle');
    
        this.tagId = id;
    }

    modalDelete(id) {
        if (id) {
          this.spinner.show();
    
          let data = {
            auth_token: this._sharedService.getCookie('auth_token'),
            id: id
          };
    
          this._tagsService.deleteTags(data).subscribe(
            data => {
              if (data.status) {
                console.log(data);
                if (data.message == 'deletedFailTags') {
                  this.toastr.error('La etiqueta está asociada a una conversación', 'Error');
                } else {
                  this.toastr.success('La etiqueta ha sido eliminada', '¡Éxito!');
                  this.updatePage();
                }
              } else {
                this.toastr.error(data.message, 'Error');
              }
              this.spinner.hide();
            },
            error => {
              this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
              //this.load = false;
              this.spinner.hide();
              this.logger.log(error);
            }
          );
        }
    }

    /*onChangeSelect(valor, id) {
        console.log(valor);
        this.spinner.show();
        let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			valor: valor,
            id : id
		};

        this._tagsService.changeClasification(data).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) {
                    this.updatePage();
                    this.toastr.success('Actualizado correctamente!', '¡Éxito!');
                } else {
                    this.toastr.error(data.message, 'Error');
                }
            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    }*/

    onFileChange(ev) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        const file = ev.target.files[0];
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            const dataString = JSON.stringify(jsonData);
            //document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
            console.log(dataString);
            this.spinner.show();
            let dataJs = {
                dataExcel : dataString
            }
            this._tagsService.uploadfiles(dataJs).subscribe(response => {
                if (response.status) {
                    console.log(response);
                    if (response.message == 'failed') {
                        this.toastr.error('Estructura del archivo incorrecta', 'Error');
                    } else {
                        this.updatePage();
                    }
                    } else {
                    this.toastr.error(response.message, 'Error');
                    }
                    this.spinner.hide();
            },
            error => {
                this.logger.log(error);
                this.spinner.hide();
            });
            //this.setDownload(dataString);
        }
        reader.readAsBinaryString(file);

        /*const fileUpload = file.item(0);
        const reader = new FileReader();
        reader.onload = (event: any) => {
            console.log(event.target.result);
            console.log(fileUpload.size);
            
        };
        reader.readAsDataURL(fileUpload);*/
    }

    setDownload(data) {
        this.willDownload = true;
        setTimeout(() => {
          const el = document.querySelector("#download");
          el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
          el.setAttribute("download", 'xlsxtojson.json');
        }, 1000)
    }

    exportAsXLSX(): void {
        
            this.userService.exportAsExcelFile(this.dataExcel, 'reporte');
          
    }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/tags/tags/tags.component.ts